import { RootState } from 'editor/src/store/index';

const isHandToolActive = (state: RootState) => state.editor.handToolActive;

export default isHandToolActive;
